import React from "react";
import {
  Box,
  Image,
  useDisclosure,
} from "@chakra-ui/react";
import ComponentModal from "./ComponentModal";
import InstagramStoryOverlay from "./InstagramStoryOverlay";

interface InstagramStoryMockupProps {
  imageUrl: string;
  profileUrl: string;
  username: string;
  timestamp: string;
}

const InstagramStoryImage = ({
  imageUrl,
  profileUrl,
  username,
  timestamp,
}: InstagramStoryMockupProps) => {
  return (
    <Box position="relative" h="100%" w="100%" bg="black" pb="80px">
      {/* Background Image */}
      <Image
        src={imageUrl}
        alt="Story"
        objectFit="contain"
        w="full"
        h="full"
      />

      <InstagramStoryOverlay
        profileUrl={profileUrl}
        username={username}
        timestamp={timestamp}
        isFallback={false}
      />
    </Box>
  );
};

const InstagramStoryMockup = ({
  imageUrl,
  profileUrl,
  username,
  timestamp,
}: InstagramStoryMockupProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box
        position="relative"
        width="100%"
        height="100%"
        borderRadius="lg"
        overflow="hidden"
        boxShadow="lg"
        bg="black"
        onClick={onOpen}
      >
        <InstagramStoryImage
          imageUrl={imageUrl}
          profileUrl={profileUrl}
          username={username}
          timestamp={timestamp}
        />
      </Box>
      <ComponentModal
        isOpen={isOpen}
        onClose={onClose}
        component={<InstagramStoryImage
          imageUrl={imageUrl}
          profileUrl={profileUrl}
          username={username}
          timestamp={timestamp}
        />}
      />
    </>
  );
};

export default InstagramStoryMockup;
